import React from "react";
import {
  Box,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';

const options = {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};
export default class ComponentToPrint extends React.Component {
  render() {
    const notSupplyDebtList = this.props.notSupplyDebtList;
    const searchData = this.props.searchData;
    

    const tableStyles = {
      table: {
        border: '1px solid #ccc',
        borderCollapse: 'collapse'
      },
      tableCell: {
        padding: '6px' 
      },
      routeNameCell: {
        width: '100px', 
        padding: '6px',
        whiteSpace: 'nowrap'
      },
      numericCell: {
        paddingRight: '30px',
        textAlign: 'right'
      }
    };

    const totalLastThreeMonthAvg = notSupplyDebtList.reduce((sum, row) => sum + Number(row.lastThreeMonthAvg), 0);
    const totalTodateCrop = notSupplyDebtList.reduce((sum, row) => sum + Number(row.todateCrop), 0);
    const totalDebtAmount = notSupplyDebtList.reduce((sum, row) => sum + Number(row.amount), 0);
    const totalLoanBalance = notSupplyDebtList.reduce((sum, row) => sum + Number(row.loanBalance), 0);

    return (
      <div>
        <h3><center><u>Not Supply Debt List Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{searchData.groupName} - {searchData.factoryName}</center></h4>
        <h4><center>Route: {searchData.routeName} </center></h4>
        <h4><center>{searchData.monthName || searchData.month}/{searchData.year}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer style={{ marginLeft: '5px', paddingRight:'5px'}} spacing={1}>
              <Table aria-label="caption table" style={tableStyles.table} size="small">
                <TableHead>
                  <TableRow style={{ borderBottom: '1px solid #ccc' }}>
                    <TableCell align={'left'} style={tableStyles.routeNameCell}>Route Name</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Registration Number</TableCell>
                    <TableCell align={'left'} style={tableStyles.routeNameCell}>Customer Name</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Last 3 Months Crop Avg (KG)</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Todate Crop (KG)</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Debt Amount (Rs.)</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Loan Balance (Rs.)</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Last Supply Month</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {notSupplyDebtList.map((data, index) => (
                    <TableRow key={index} style={{ height: '36px' }}>
                      <TableCell align={'left'} component="th" scope="row" style={{ ...tableStyles.routeNameCell, borderBottom: "none" }}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ ...tableStyles.tableCell, borderBottom: "none" }}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ ...tableStyles.routeNameCell, borderBottom: "none" }}>
                        {data.name}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, borderBottom: "none" }}>
                        {Number(data.lastThreeMonthAvg).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, borderBottom: "none" }}>
                        {Number(data.todateCrop).toLocaleString()}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, borderBottom: "none" }}>
                        {Number(data.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, borderBottom: "none" }}>
                        {Number(data.loanBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ ...tableStyles.tableCell, borderBottom: "none" }}>
                        {data.lastSupplyMonth}
                      </TableCell>
                    </TableRow>
                  ))}
                  
                  <TableRow style={{ borderTop: '1px solid #ccc' }}>
                    <TableCell colSpan={3} align={'left'} component="th" scope="row" style={{ ...tableStyles.tableCell, fontWeight: "bold", borderBottom: "none" }}>
                      Total
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, fontWeight: "bold", borderBottom: "none" }}>
                      {totalLastThreeMonthAvg.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, fontWeight: "bold", borderBottom: "none" }}>
                      {totalTodateCrop.toLocaleString()}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, fontWeight: "bold", borderBottom: "none" }}>
                      {totalDebtAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, fontWeight: "bold", borderBottom: "none" }}>
                      {totalLoanBalance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ ...tableStyles.tableCell, fontWeight: "bold", borderBottom: "none" }}>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}